"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VerifiableObject = /** @class */ (function () {
    function VerifiableObject(proof) {
        this.proof = proof;
    }
    ;
    return VerifiableObject;
}());
exports.VerifiableObject = VerifiableObject;
//# sourceMappingURL=VerifiableObject.js.map